"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error for when an assignment progress field failed validation
 * @param {string} field the field that failed validation
 * @param {string} message the validation message
 */
class UserNotPermittedError extends client_library_1.ExtendableError {
    constructor() {
        super(`User not permitted to peform that operation`);
    }
}
exports.default = UserNotPermittedError;
//# sourceMappingURL=UserNotPermittedError.js.map